import React from 'react';
import PropTypes from 'prop-types';
import { Area, AreaChart, ResponsiveContainer, Tooltip, XAxis } from 'recharts';

import {
  fnFormatChartData,
  fnFormatTooltipLabel,
  fnFormatTooltipValue,
  oTooltipContentStyle,
  oTooltipItemStyle,
} from './helpers';

const FundFinancialChart = ({ oFinancialData }) => {
  const { FISCALYEAR } = oFinancialData;
  const aChartData = fnFormatChartData(oFinancialData);

  return (
    <div className='philanthropyReport__chartOuterWrapper philanthropyReport__overviewContainer'>
      <h4 className='philanthropyReport__fundOverviewTitle t-label'>
        Fiscal Year {FISCALYEAR}
      </h4>
      <div className='philanthropyReport__chartXAxisBackdrop' />
      <div className='philanthropyReport__chartWrapper'>
        <ResponsiveContainer>
          <AreaChart data={aChartData}>
            <defs>
              <linearGradient
                id='verticalWhiteFade'
                x1='0'
                y1='0'
                x2='0'
                y2='1'
              >
                <stop offset='0%' stopColor='white' stopOpacity={0.8} />
                <stop offset='100%' stopColor='white' stopOpacity={0} />
              </linearGradient>
            </defs>
            <XAxis
              dataKey='name'
              className='philanthropyReport__chartXAxis'
              padding={{ left: 56, right: 56 }}
              axisLine={false}
              tickLine={false}
            />
            <Tooltip
              formatter={fnFormatTooltipValue}
              contentStyle={oTooltipContentStyle}
              labelStyle={{ fontWeight: '500' }}
              itemStyle={oTooltipItemStyle}
              labelFormatter={fnFormatTooltipLabel}
            />
            <Area
              type='monotone'
              dataKey='value'
              fill='url(#verticalWhiteFade)'
              dot
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

FundFinancialChart.propTypes = {
  oFinancialData: PropTypes.shape({
    FISCALYEAR: PropTypes.string,
    FISCAL_YEAR_BEGINNING_MARKET_VALUE: PropTypes.string,
    FISCAL_YEAR_ENDING_MARKET_VALUE: PropTypes.string,
    VALUE_OVER_TIME: PropTypes.arrayOf(
      PropTypes.shape({
        INTERVAL: PropTypes.string,
        ENDING_MARKET_VALUE: PropTypes.string,
      })
    ),
  }),
};

FundFinancialChart.defaultProps = {
  oFinancialData: [],
};

export default FundFinancialChart;
